<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-light rounded">
        <div class="container-fluid">
            <a class="navbar-brand ff-l1" @click="$router.push({ name: 'home' })" role="button"><i
                    class="bi bi-scissors me-1"></i>Dressmaker</a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navMenu">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navMenu">
                <div class="row p-1 bg-error my-2 d-md-none">
                    <div class="col d-flex justify-content-start align-items-center">
                        <span class="bg-body text-black btn" role="button" @click="$router.push({name:'auth-user'})">
                            <i class="bi bi-person"></i>
                            {{ userStore.$state.user.name }} {{ userStore.$state.user.prenoms }}
                        </span>
                    </div>
                    <div class="col d-flex align-items-center justify-content-end">
                        <div>
                            <span class="btn btn-info" role="button" @click="logout">
                                <i class="bi bi-box-arrow-left"></i>
                                Déconnexion
                            </span>
                        </div>
                    </div>
                </div>
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <li class="nav-item"><router-link class="nav-link" to="/"><i
                                class="bi bi-house me-1"></i>Accueil</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/clients"><i
                                class="bi bi-people me-1"></i>Type tissus</router-link></li>
                    <li class="nav-item"><router-link class="nav-link" to="/clients"><i
                                class="bi bi-card-list me-1"></i>Bilan</router-link></li>
                </ul>
                <div class="d-none d-md-block">
                    <!-- Example single danger button -->
                    <div class="dropdown">
                        <a class="btn btn-info dropdown-toggle" href="#" role="button" id="dropdownMenuLink"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            <span>
                                <span class="rounded bg-info p-2"><i class="bi bi-person"></i></span>
                                {{ userStore.$state.user.name }} {{
                                    userStore.$state.user.prenoms
                                }}
                            </span>
                        </a>

                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                            <li><a class="dropdown-item" href="#"><i class="bi bi-person"></i> Profil</a></li>
                            <li>
                                <hr class="dropdown-divider">
                            </li>
                            <li><a class="dropdown-item" role="button" @click="logout"> <i
                                        class="bi bi-box-arrow-left"></i> Deconnexion</a></li>
                        </ul>
                    </div>

                </div>
                <div class="mx-4"></div>
            </div>
        </div>
    </nav>
</template>

<script>
import { useUserStore } from '@/store/userStore';

export default {
    name: "Nav",
    computed: {
        userStore: () => useUserStore()
    },
    methods: {
        logout() {
            this.$api.post('auth/logout')
                .then(() => {
                    this.$router.push({ name: 'login' })
                })
                .catch(() => {

                })
        }
    }
}
</script>